import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const IndustrySettings = ({ currentIndustry, onSave }) => {
  const [selectedIndustry, setSelectedIndustry] = useState(currentIndustry || 'technology');

  const industryOptions = [
    { 
      value: 'technology', 
      label: 'Technology & Software',
      description: 'SaaS, IT services, software development'
    },
    { 
      value: 'real-estate', 
      label: 'Real Estate',
      description: 'Property sales, commercial and residential'
    },
    { 
      value: 'insurance', 
      label: 'Insurance',
      description: 'Life, health, property insurance products'
    },
    { 
      value: 'financial', 
      label: 'Financial Services',
      description: 'Banking, investments, financial planning'
    },
    { 
      value: 'healthcare', 
      label: 'Healthcare',
      description: 'Medical devices, pharmaceuticals, health services'
    },
    { 
      value: 'automotive', 
      label: 'Automotive',
      description: 'Vehicle sales, parts, and services'
    },
    { 
      value: 'retail', 
      label: 'Retail',
      description: 'Consumer goods, e-commerce, retail services'
    },
    { 
      value: 'manufacturing', 
      label: 'Manufacturing',
      description: 'Industrial equipment, B2B manufacturing'
    },
    { 
      value: 'telecommunications', 
      label: 'Telecommunications',
      description: 'Telecom services, network solutions'
    },
    { 
      value: 'education', 
      label: 'Education',
      description: 'EdTech, training programs, educational services'
    }
  ];

  const handleSave = () => {
    onSave({ industry: selectedIndustry });
  };

  const getIndustryImpact = () => {
    return [
      'Objection Dojo will show industry-specific objections',
      'Daily Drills will feature relevant sales scenarios',
      'Script Lab will generate industry-appropriate messaging',
      'AI coaching will use industry terminology and best practices'
    ];
  };

  return (
    <div className="space-y-6">
      <Select
        label="Sales Industry"
        description="Select the industry that best matches your sales focus"
        options={industryOptions}
        value={selectedIndustry}
        onChange={setSelectedIndustry}
        searchable
      />
      <div className="bg-muted/50 rounded-lg p-4">
        <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="Lightbulb" size={18} color="var(--color-accent)" />
          How this affects your coaching
        </h3>
        <ul className="space-y-2">
          {getIndustryImpact()?.map((impact, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-foreground">
              <Icon name="Check" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
              <span>{impact}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 flex items-start gap-3">
        <Icon name="AlertTriangle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
        <div className="text-sm">
          <p className="font-medium text-foreground mb-1">Important Note</p>
          <p className="text-muted-foreground">
            Changing your industry will update all coaching content but will not reset your progress or streak. Your existing drill history will remain accessible.
          </p>
        </div>
      </div>
      <div className="pt-4">
        <Button 
          variant="default" 
          onClick={handleSave}
          iconName="Save"
          iconPosition="left"
        >
          Update Industry
        </Button>
      </div>
    </div>
  );
};

export default IndustrySettings;